export default "__VITE_ASSET__oqE$sCSo__"